module.exports = __webpack_public_path__ + "static/media/8.303cc250.jpg";